<template>
  <div class="m-b-32" v-bind="$attrs">
    <WdsStack direction-column>
      <div class="tw-mb-4">
        <WdsHeading type="title1" class="tw-text-indigo-500">{{ companyName }}</WdsHeading>
        <WdsHeading type="title1">{{ $t('Invited you to their talent pool!') }}</WdsHeading>
      </div>
      <WdsText large secondary>
        {{
          $t(
            'Create a Worksome account and use that chance to create an outstanding profile to get noticed and hired easily.',
          )
        }}
      </WdsText>
    </WdsStack>
  </div>
</template>

<script setup lang="ts">
import { WdsHeading, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/composables/translation'

defineProps({
  companyName: {
    type: String,
    required: true,
  },
})
</script>
